export default {
  setSetting(state, data) {
    state.setting = data || [];
  },
  setBooths(state, data) {
    state.booths = data || [];
  },
  setStoreOptions(state, data) {
    state.storeOptions = data || [];
  },
  setBranchUserPersons(state, data) {
    state.branchUserPersons = data || [];
  },
  setStores(state, data) {
    state.stores = data || [];
  },
  // لیست صفحه غرفه‌ها (جدا از دراپ‌داون booths)
  setBoothList(state, data) {
    state.boothList = data || [];
  },
  setPreOrders(state, data) {
    state.preOrders = data || [];
  },
  setPreOrderById(state, data) {
    state.preOrderById = data;
  },
};
